import { render, staticRenderFns } from "./PayView.vue?vue&type=template&id=66d73b96&scoped=true"
import script from "./PayView.vue?vue&type=script&lang=js"
export * from "./PayView.vue?vue&type=script&lang=js"
import style0 from "./PayView.vue?vue&type=style&index=0&id=66d73b96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d73b96",
  null
  
)

export default component.exports